export const GET_MY_POST = "USER@GET_MY_POST";
export const GET_MY_POST_INIT = "USER@GET_MY_POST_INIT";
export const GET_MY_POST_SUCCESS = "USER@GET_MY_POST_SUCCESS";
export const GET_MY_POST_FAILED = "USER@GET_MY_POST_FAILED";

export const DELETE_MY_POST = "USER@DELETE_MY_POST";
export const DELETE_MY_POST_INIT = "USER@DELETE_MY_POST_INIT";
export const DELETE_MY_POST_SUCCESS = "USER@DELETE_MY_POST_SUCCESS";
export const DELETE_MY_POST_FAILED = "USER@DELETE_MY_POST_FAILED";
